import { IHost } from "@Interfaces";
import {
    API_ACTION_TYPES,
    FETCH_STATUS,
    isEmpty,
    QUERY_PARAMS,
    SELECTORS,
    useFetchStatus,
} from "@Utils";
import { useSelector } from "react-redux";
import { IEventModule } from "../root/IEventModule";

export const default_depth_index = 0;

export const getPlanData = ({
    host,
    planId,
}: {
    host: IHost.IStore;
    planId?: string | null;
}) => {
    const plansDataInHost = host?.plans || {};
    let planData: IHost.IPlanDetail = { listings: [] };
    if (planId) {
        planData = {
            ...planData,
            ...plansDataInHost.details?.[planId],
            ...plansDataInHost.list?.filter(p => p.uuid === planId)?.[0],
        };
    }

    return planData;
};

export const usePlanDropdownBaseProps = ({
    urlQueryParams,
}: {
    urlQueryParams: IEventModule.IProps["urlQueryParams"];
}) => {
    const host = useSelector(SELECTORS.host);
    const planId = urlQueryParams?.[QUERY_PARAMS.PLAN_ID] as string;
    const planData = getPlanData({
        host,
        planId,
    });
    const planListings = planData?.listings;
    const planMetadata = planData?.metadata;

    const planFetchStatus = useFetchStatus(API_ACTION_TYPES.FETCH_PLAN_DETAILS);

    const hideComponent: boolean = !(
        (planFetchStatus === FETCH_STATUS.FETCHED && !isEmpty(planListings)) ||
        planFetchStatus === FETCH_STATUS.FETCHING
    );

    return {
        hideComponent,
        planFetchStatus,
        planId,
        planListings,
        planMetadata,
    };
};
